export default class ProxyDevice {
  constructor(device_guid, device_attributes = false) {
    this.device_guid = device_guid
    
    this.device_attributes = device_attributes
    
    this.device = null
    this.shouldFetchMetrics = false
    
    if (this.device_attributes) {
        console.log('ProxyDevice ' + this.device_guid + ' device_attributes', device_attributes)
    }
    
    return new Proxy(this, {
      get: (target, prop, receiver) => {
        // Expose device_guid & setDevice even before hydration
        if (prop in target) {
          return Reflect.get(target, prop, receiver)
        }
        
        // If no device yet, just return false...
        if (!target.device) {
          var silenceFunctions = ['deviceName', 'canControl', 'canEdit', 'isUpdating', 'hasUpdates', 'isOnline', 'entitlements', 'hasMetadataKey']
          
          if (silenceFunctions.includes(prop)) {
            return () => { return false }
          } else if (prop == 'fetchMetrics') {
            receiver.shouldFetchMetrics = true
            return () => { return false }
          }
          
          return false
        }
        
        const value = target.device[prop]
        
        // Forward methods and preserve `this`
        if (typeof value === "function") {
          return value.bind(target.device)
        }
        
        return value
      },
      
      set: (target, prop, value) => {
        if (prop in target) {
          target[prop] = value
          return true
        }
        
        if (target.device) {
          target.device[prop] = value
          return true
        }
        
        console.log('ProxyDevice ' + this.device_guid + ' unhandled set ' + prop + '=' + value)
        
        return true
      }
    })
  }
  
  setDevice(device) {
    this.device = device
    
    if (this.device && this.device_attributes) {
      console.log('ProxyDevice ' + this.device_guid + ' setting device_attributes', this.device_attributes)
      
      for (var prop in this.device_attributes) {
        this.device[prop] = this.device_attributes[prop]
      }
    }
    
    if (this.device && this.shouldFetchMetrics) {
      this.device.fetchMetrics()
    }
  }
  
  icon() {
    if (this.device) {
      return this.device.icon()
    }
    return '$videon_logo'
  }
  
  isReady() {
    if (this.device) {
      return this.device.isReady()
    }
    return false
  }
}